const APPOINTMENT_CHANNEL_CODE = {
  BOOKED_BY_GOOGLE: 'BWG_',
};

export default Object.freeze(APPOINTMENT_CHANNEL_CODE);
